import type { KioskRole } from "./kioskRoles";

/**
 * Les AFFILIÉS hors du cockpit : leur espace est app.rishfans.com.
 *
 * Kayla, 14-10-2026 : un affilié qui se connecte sur le cockpit, « ça lui dit
 * d'aller sur RishFans, le redirige et il doit se connecter là-bas ». Même
 * geste que le déménagement des chatteurs (`demenagementCyrano.ts`) : un écran
 * qui dit où aller, puis le départ. Autre domaine, donc autre session : il se
 * reconnecte sur l'écran RishFans (`rishfans/ConnexionRishfans`).
 *
 * Les rôles d'affilié SEULS — `partenaire_rishfans` et `affilie`, dont toute
 * la page vit déjà sur RishFans. ⛔ Pas le `collaborateur` : Marko garde le
 * cockpit pour Twitter et ses canaux Telegram, qui n'existent pas sur
 * app.rishfans.com (Kayla, 14-10).
 *
 * Partout sauf sur RishFans même (où ce shell n'est de toute façon pas monté)
 * et sur le poste de dev : dozka.app, cyrano.work et l'app desktop renvoient.
 */
export const ESPACE_RISHFANS = "https://app.rishfans.com/";

const ROLES_RISHFANS: ReadonlySet<KioskRole> = new Set(["partenaire_rishfans", "affilie"]);

export function doitPartirSurRishfans({
  kioskRole,
  surRishfans,
  enDev,
}: {
  kioskRole: KioskRole | null;
  surRishfans: boolean;
  enDev: boolean;
}): boolean {
  return kioskRole !== null && ROLES_RISHFANS.has(kioskRole) && !surRishfans && !enDev;
}
